export const fallbackProfile = {
  full_name: '',
  role_title: '',
  bio: '',
  avatar_url: '',
  avatar_base64: '',
  tech_stack: [],
  email: '',
  github: '',
  linkedin: ''
};

export const fallbackProjects = [];

export const navLinks = ['About', 'Stack', 'Projects', 'Contact'];

export const techMeta = {
  JavaScript: { icon: 'JS', accent: 'text-amber-300 border-amber-300/50 bg-amber-300/10' },
  React: { icon: 'RE', accent: 'text-cyan-300 border-cyan-300/50 bg-cyan-300/10' },
  'Node.js': { icon: 'NO', accent: 'text-emerald-300 border-emerald-300/50 bg-emerald-300/10' },
  Express: { icon: 'EX', accent: 'text-slate-200 border-slate-300/40 bg-slate-200/10' },
  PostgreSQL: { icon: 'PG', accent: 'text-sky-300 border-sky-300/50 bg-sky-300/10' },
  Tailwind: { icon: 'TW', accent: 'text-teal-300 border-teal-300/50 bg-teal-300/10' },
  'Tailwind CSS': { icon: 'TW', accent: 'text-teal-300 border-teal-300/50 bg-teal-300/10' },
  TypeScript: { icon: 'TS', accent: 'text-blue-300 border-blue-300/50 bg-blue-300/10' },
  Neon: { icon: 'NN', accent: 'text-lime-300 border-lime-300/50 bg-lime-300/10' },
  REST: { icon: 'AP', accent: 'text-fuchsia-300 border-fuchsia-300/50 bg-fuchsia-300/10' },
  SQL: { icon: 'SQ', accent: 'text-indigo-300 border-indigo-300/50 bg-indigo-300/10' }
};
